// Translation for sk
export const sk = {
        common: {
            save: 'Uložiť',
            cancel: 'Zrušiť',
            close: 'Zatvoriť',
            delete: 'Odstrániť',
            edit: 'Upraviť',
            activate: 'Aktivovať',
            add: 'Pridať',
            saving: 'Ukladanie...',
            loading: 'Načítavanie...',
            active: 'AKTÍVNE',
            inUse: 'V používaní',
            test: 'Test',
            searchApps: 'Vyhľadávať aplikácie...',
            betaBanner: 'BETA - Služba ešte nie je dostupná!'
        },
        header: {
            creditBalance: 'Stav',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Prihlásiť sa',
            signUp: 'Registrácia',
            username: 'Používateľské meno',
            password: 'Heslo',
            continue: 'Pokračovať',
            noAccount: 'Nemáš účet?',
            hasAccount: 'Už máš účet?',
            loginError: 'Chyba pri prihlásení',
            invalidCredentials: 'Neplatné používateľské meno alebo heslo',
            rateLimited: 'Príliš veľa pokusov o prihlásenie. Prosím čakaj.',
            sessionExpired: 'Tvoja relácia vypršala. Prosím použi nový kúzelný odkaz.',
            magicLinkInvalid: 'Odkaz na prihlásenie je neplatný alebo vypršal.',
            magicLinkSuccess: 'Vitaj! Úspešne si sa prihlásil.',
            magicLinkProcessing: 'Spracovávanie prihlásenia...',
            connectionError: 'Chyba pripojenia. Prosím skús znova.'
        },
        profile: {
            myProgress: 'Môj Pokrok v Učení',
            signOut: 'Odhlásiť sa',
            plan: 'Plán: '
        },
        settings: {
            title: 'Nastavenia',
            tabs: {
                uiSettings: 'Nastavenia UI',
                systemPrompt: 'Systémová Výzva',
                llmProfiles: 'Profily LLM',
                ttsProfiles: 'Profily TTS',
                language: 'Jazyk',
            },
            uiSettings: {
                title: 'Používateľské Rozhranie',
                themeMode: 'Režim Témy',
                darkMode: 'Tmavý Režim',
                lightMode: 'Svetlý Režim',
                themeColor: 'Farba Témy',
                themeColorDesc: 'Vyber farbu zdôraznenia pre tlačidlá, ikony a zvýraznenia',
                background: 'Pozadie',
                backgroundDesc: 'Vyber pozadie pre tvoj pracovný priestor',
                selectBackgroundColor: 'Vyber Farbu Pozadia',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Zameranie',
                    concentration: 'Sústredenie',
                    relaxation: 'Relaxácia',
                    lianas: 'Liány',
                    color: 'Farba'
                },
                backgroundColors: {
                    deepDark: 'Hlboko Tmavá',
                    darkGrey: 'Tmavosivá',
                    midnightBlue: 'Polnočná Modrá',
                    indigo: 'Indigo',
                    darkTeal: 'Tmavo Modrozelená',
                    brown: 'Hnedá',
                    darkRed: 'Tmavo Červená',
                    deepPurple: 'Hlboko Fialová',
                    pureWhite: 'Čistá Biela',
                    softWhite: 'Mäkká Biela',
                    lightGrey: 'Svetlosivá',
                    paleBlue: 'Bledá Modrá',
                    paleGreen: 'Bledá Zelená',
                    paleOrange: 'Bledá Oranžová',
                    lavender: 'Levanduľa',
                    blueGrey: 'Modrosivá'
                }
            },
            systemPrompt: {
                label: 'Systémová Výzva:',
                placeholder: 'Načítavanie systémovej výzvy...',
                emptyError: 'Systémová výzva nemôže byť prázdna!',
                saveSuccess: '✓ Systémová výzva bola úspešne uložená!',
                loadError: 'Chyba pri načítavaní systémovej výzvy',
                saveError: 'Chyba pri ukladaní'
            },
            llmProfiles: {
                addButton: '+ Pridaj Nové Spojenie',
                newConnection: 'Nové Spojenie',
                editConnection: 'Uprav Spojenie',
                emptyState: 'Žiadne dostupné LLM spojenia. Klikni nižšie pre pridanie.',
                loadingProfiles: 'Načítavanie profilov...',
                nameLabel: 'Názov *',
                namePlaceholder: 'napr. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API Kľúč *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, atď.',
                allFieldsRequired: 'Všetky polia musia byť vyplnené!',
                saveSuccess: '✓ Profil bol úspešne uložený!',
                deleteConfirm: 'Si si istý, že chceš odstrániť "{name}"?',
                profileNotFound: 'Profil nenájdený!',
                loadError: 'Chyba pri načítavaní profilov',
                saveError: 'Chyba pri ukladaní',
                activateError: 'Chyba pri aktivácii',
                deleteError: 'Chyba pri odstraňovaní',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Pridaj Nový Hlas',
                newVoice: 'Nový Hlas',
                editVoice: 'Uprav Hlas',
                emptyState: 'Žiadne dostupné TTS profily. Klikni nižšie pre pridanie.',
                loadingProfiles: 'Načítavanie TTS profilov...',
                nameLabel: 'Názov',
                namePlaceholder: 'napr. Môj ElevenLabs Adam',
                providerLabel: 'Poskytovateľ',
                providerPlaceholder: 'napr. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API Kľúč *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'ID Modelu *',
                modelIdPlaceholder: 'napr. eleven_monolingual_v1',
                voiceIdLabel: 'ID Hlasu',
                voiceIdPlaceholder: 'napr. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Všetky polia musia byť vyplnené!',
                saveSuccess: '✓ TTS profil bol úspešne uložený!',
                deleteConfirm: 'Si si istý, že chceš odstrániť "{name}"?',
                loadError: 'Chyba pri načítavaní TTS profilov',
                saveError: 'Chyba pri ukladaní',
                activateError: 'Chyba pri aktivácii',
                deleteError: 'Chyba pri odstraňovaní'
            },
            language: {
                title: 'Vyber Jazyk',
                description: 'Vyber svoj preferovaný jazyk pre používateľské rozhranie'
            },
        },
        chat: {
            ready: 'Pripravené',
            start: 'ZAČAŤ',
            stop: 'ZASTAVIŤ',
            initialMessage: 'Klikni ZAČAŤ pre rozhovor v reálnom čase.',
            listening: 'Počúvam...',
            speaking: 'Thorsten hovorí...',
            userLabel: 'Ty',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Napíš správu...',
            send: 'Odoslať',
            loginRequired: 'Prosím prihlásiť sa na používanie tejto služby.',
            loginButton: 'Prihlásiť sa Teraz',
            magicLinkRequired: 'Prosím použi kúzelný odkaz na prihlásenie.',
            creditLimitError: 'Vaša hodinová kvóta bola vyčerpaná. Upgradujte svoj plán (Medium/Premium) na pokračovanie.',
            serviceDisabled: 'Chatová služba je momentálne nedostupná. Skúste to prosím neskôr.'
        },
        notifications: {
            error: 'Chyba',
            success: 'Úspech',
            info: 'Informácia',
            unknownError: 'Vyskytla sa neznáma chyba'
        },
        cookie: {
            message: 'Táto webová stránka používa súbory cookie, aby vám poskytla čo najlepší zážitok z používania.',
            accept: 'Súhlasím'
        },
        curriculum: {
                buttonLabel: 'Učebné osnovy',
                buttonTitle: 'Zobraziť obsah učebných osnov',
                modalTitle: '{app} Učebné osnovy',
                sections: {
                    topic: 'Téma učebných osnov',
                    explanation: 'Vysvetlenie pre deti',
                    studentProfile: 'Profil študenta'
                },
                topic: {
                    empty: 'V backend-e nie je k tejto mikro-aplikácii priradená žiadna téma učebných osnov.',
                    missingDetail: 'Podrobné údaje o učebných osnovách pre túto mikro-aplikáciu ešte nie sú v backend-e k dispozícii.',
                    learningGoals: 'Ciele učenia',
                    prerequisites: 'Predpoklady',
                    unitLabel: 'Jednotka',
                    durationLabel: 'Trvanie',
                    difficultyLabel: 'Obtiažnosť',
                    hours: 'hod',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'Nie je k dispozícii žiadne vysvetlenie pre deti.',
                    loadingPrepare: 'AI pripravuje vysvetlenie',
                    loadingExplain: 'AI vysvetľuje tému jazykom vhodným pre deti',
                    requestFailed: 'Vysvetlenie pre deti sa nepodarilo vygenerovať.'
                },
                studentProfile: {
                    country: 'Krajina',
                    region: 'Štát / Región',
                    schoolType: 'Typ školy',
                    grade: 'Ročník',
                    noContext: 'Nie je k dispozícii žiadny kontext študenta.',
                    childProfileNotFound: 'Pre aktuálne prihlásenie nebol v backend-e nájdený žiadny profil študenta.',
                    loginProfileIncomplete: 'Prihlasovací profil ešte neobsahuje úplný kontext študenta.',
                    educationContextNotFound: 'Profil študenta bol nájdený, ale nie je nastavené žiadne priradenie učebných osnov.',
                    noToken: 'Nenašiel sa žiadny prihlásený študent.'
                },
                errors: {
                    signInRequired: 'Pre zobrazenie učebných osnov sa prosím prihláste.',
                    appIdMissing: 'Chýba ID aplikácie.',
                    loadFailed: 'Nepodarilo sa načítať údaje učebných osnov.'
                }
            }
    };
